import axios, { AxiosError } from 'axios';
import { reportInfo } from './shared/utilities/reportError';

export function debugChunkLoadingError(chunkLoadingError: Error) {
  // we are unsure of why these chunks fail to load.
  // maybe lets try to find the URL of the chunk and load it via axios, to find and hash the response code and response body.
  const url = determineChunkLoadUrl(chunkLoadingError.message);
  if (url) {
    // try to make a request to the URL
    axios
      .get(url)
      .then((response) => {
        // report this to Rollbar, as it is unexpected really.
        reportInfo('debugChunkLoadingError: successful request after chunk loading error', {
          chunkUrl: url,
          responseStatus: response.status,
        });
      })
      .catch((error: AxiosError) => {
        // report this to Rollbar, this might be our issue
        reportInfo('debugChunkLoadingError: errored request after chunk loading error', {
          chunkUrl: url,
          errorMessage: error.message,
          responseStatus: error.response?.status,
          responseBody: error.response?.data,
        });
      });
  }
}

function determineChunkLoadUrl(message: string) {
  // the message looks like 'ChunkLoadError: Loading chunk 6518 failed. (error: https://d2n5ied94mazop.cloudfront.net/packs/js/6518-e4b0e44081f49bbc192b.chunk.js)'
  const packRegex = /https:\/\/d2n5ied94mazop\.cloudfront\.net\/packs\/js\/[a-f0-9-]+\.chunk\.js/gm;

  const urlMatches = message.match(packRegex);
  if (urlMatches) {
    return urlMatches[0];
  }

  return null;
}
